import { gql } from "@apollo/client"

export const GET_USERS = gql`
  query GetUsers($uid: ID!, $organization_id: ID!) {
    users(staff_id: $uid, organization_id: $organization_id) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
      organization_name
      organization_id
      staff_user_status
      staff_role
      staff_role_name
      staff_email_address
      staff_last_login
    }
  }
`

export const GET_USER = gql`
  query GetUser($uid: ID!, $organization_id: ID!) {
    user(staff_id: $uid, organization_id: $organization_id) {
      staff_id
      staff_id_stamp
      staff_name_first
      staff_name_last
      staff_email_address
      organization_id
      staff_role
      staff_last_login
    }
  }
`

export const LOAD_FORM = gql`
  query LoadForm($uid: ID!, $organization_id: ID!) {
    roles: rolesByUid(
      staff_id: $uid
      organization_id: $organization_id
      group_type: 2
    ) {
      rol_id
      rol_name
    }
  }
`

export const EDIT_USER = gql`
  mutation EditUser(
    $staff_id: String!
    $staff_id_stamp: String!
    $staff_name_first: String
    $staff_name_last: String
    $staff_email_address: String
    $staff_password: String
    $staff_role: Int
    $staff_organization_id: String
    $admin_staff_id: String!
    $admin_staff_alias: String!
    $admin_staff_enterprise_id: String!
    $admin_staff_organization_id: String!
    $admin_staff_enterprise_alias: String!
    $admin_staff_organization_alias: String!
  ) {
    editUser(
      staff_id: $staff_id
      staff_id_stamp: $staff_id_stamp
      staff_name_first: $staff_name_first
      staff_name_last: $staff_name_last
      staff_email_address: $staff_email_address
      staff_account_password: $staff_password
      staff_role: $staff_role
      staff_organization_id: $staff_organization_id
      admin_staff_id: $admin_staff_id
      admin_staff_alias: $admin_staff_alias
      admin_staff_enterprise_id: $admin_staff_enterprise_id
      admin_staff_organization_id: $admin_staff_organization_id
      admin_staff_enterprise_alias: $admin_staff_enterprise_alias
      admin_staff_organization_alias: $admin_staff_organization_alias
    ) {
      staff_id
    }
  }
`

export const VERIFY_EMAIL_AVAILABLE = gql`
  query VerifyEmail($email: String!) {
    emailAddressVerifier(email: $email) {
      data
    }
  }
`

//$staff_user_status_x: String
export const ADD_USER = gql`
  mutation AddUser(
    $staff_name_first: String!
    $staff_name_last: String!
    $staff_email_address: String!
    $staff_password: String!
    $staff_role: Int!
    $staff_organization_id: String!
    $admin_staff_id: String!
    $admin_staff_alias: String!
    $admin_staff_enterprise_id: String!
    $admin_staff_organization_id: String!
    $admin_staff_enterprise_alias: String!
    $admin_staff_organization_alias: String!
  ) {
    addUser(
      staff_name_first: $staff_name_first
      staff_name_last: $staff_name_last
      staff_email_address: $staff_email_address
      staff_account_password: $staff_password
      staff_role: $staff_role
      staff_organization_id: $staff_organization_id
      admin_staff_id: $admin_staff_id
      admin_staff_alias: $admin_staff_alias
      admin_staff_enterprise_id: $admin_staff_enterprise_id
      admin_staff_organization_id: $admin_staff_organization_id
      admin_staff_enterprise_alias: $admin_staff_enterprise_alias
      admin_staff_organization_alias: $admin_staff_organization_alias
    ) {
      staff_id
      isNewUser
    }
  }
`

export const ADD_ORGANIZATION = gql`
  mutation AddOrganization(
    $staff_id: String!
    $organization_name: String!
    $staff_name_first: String!
    $staff_name_last: String!
    $staff_email_address: String!
    $staff_account_password: String!
    $organization_country: String
    $organization_address: String
    $organization_city: String
    $organization_state: String
    $organization_zip_code: String
    $organization_website: String
    $organization_email_address: String
    $organization_phone_number: String
    $organization_type: String
    $enterprise_id: String
    $admin_staff_enterprise_id: String
    $admin_staff_organization_id: String
    $admin_staff_enterprise_alias: String
    $admin_staff_organization_alias: String
    $staff_alias: String
  ) {
    addOrganization(
      staff_id: $staff_id
      organization_name: $organization_name
      organization_country: $organization_country
      organization_address: $organization_address
      organization_city: $organization_city
      organization_state: $organization_state
      organization_zip_code: $organization_zip_code
      organization_website: $organization_website
      organization_email_address: $organization_email_address
      organization_phone_number: $organization_phone_number
      organization_type: $organization_type
      staff_name_first: $staff_name_first
      staff_name_last: $staff_name_last
      staff_email_address: $staff_email_address
      staff_account_password: $staff_account_password
      enterprise_id: $enterprise_id
      admin_staff_enterprise_id: $admin_staff_enterprise_id
      admin_staff_organization_id: $admin_staff_organization_id
      admin_staff_enterprise_alias: $admin_staff_enterprise_alias
      admin_staff_organization_alias: $admin_staff_organization_alias
      staff_alias: $staff_alias
      microservices: []
    ) {
      organization_id
      organization_admins {
        staff_id
        isNewUser
      }
    }
  }
`

export const EDIT_ORGANIZATION = gql`
  mutation EditOrganization(
    $staff_id: String!
    $organization_id: String
    $organization_name: String
    $organization_country: String
    $organization_address: String
    $organization_city: String
    $organization_state: String
    $organization_zip_code: String
  ) {
    editOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
      organization_name: $organization_name
      organization_country: $organization_country
      organization_address: $organization_address
      organization_city: $organization_city
      organization_state: $organization_state
      organization_zip_code: $organization_zip_code
    ) {
      organization_id
    }
  }
`

export const GET_ORGANIZATION_ADDRESS = gql`
  query get_organization_address($uid: ID!, $organization_id: ID!) {
    organization(staff_id: $uid, organization_id: $organization_id) {
      organization_country
      organization_address
      organization_city
      organization_state
      organization_zip_code
    }
  }
`

export const GET_USERS_FROM_LIST = gql`
  query get_users_from_list($list: [ID]) {
    usersFromList(list: $list) {
      staff_id
      staff_name_first
      staff_name_last
      staff_full_name
      staff_email_address
      organization_id
      organization_alias
      organization_name
      organization_type
    }
  }
`

export const GET_ORGANIZATIONS = gql`
  query get_organizations($staff_id: ID!) {
    organizationsByUid(staff_id: $staff_id) {
      organization_id
      organization_name
    }
    getAllEnterprise(staff_id: $staff_id) {
      organization_id: enterprise_id
      organization_name: enterprise_name
    }
  }
`
